import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import img1 from "../../assets/images/carrer_img-768x768.webp";

const Apply = () => {
  const domains = [
    "Physical Design",
    "Design for Test (DFT)",
    "Design Verification",
    "Synthesis & Static Timing Analysis (STA)",
    "EM/IR/PDN",
    "Analog Layout"
  ];

  const [formData, setFormData] = useState<any>({
    name: "",
    email: "",
    phone: "",
    domain: "",
    experience: "",
    relevant: "",
    lastDate: "",
    message: "",
    file: null
  });

  const [errors, setErrors] = useState<any>({});

  // Handle input change
  const handleChange = (e:any) => {
    const { name, value, files } = e.target;

    if (name === "file") {
      setFormData({ ...formData, file: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Validation function
  const validate = () => {
    let newErrors:any = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.phone) {
      newErrors.phone = "Phone is required";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid 10-digit number";
    }

    if (!formData.domain) newErrors.domain = "Please select domain";

    if (!formData.experience)
      newErrors.experience = "Select experience";

    if (!formData.relevant)
      newErrors.relevant = "Select relevant experience";

    if (!formData.lastDate)
      newErrors.lastDate = "Select last working day";

    if (!formData.file)
      newErrors.file = "Resume is required";

    if (!formData.message.trim())
      newErrors.message = "Message is required";

    return newErrors;
  };

  // Submit
  const handleSubmit = (e:any) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      console.log("Form Data:", formData);

      // API call here
      alert("Form submitted successfully!");
    }
  };

  return (
    <div>
      <section className="contact-hero">
        <Container>
          <h1>Apply</h1>
          <p>
            <NavLink to="/">Home</NavLink> <span>»</span> Apply
          </p>
        </Container>
      </section>

      <div className="container">
        <div className="row">
          <div className="col-md-4 mt-5 mb-4 text-center">
            <h5 className="mt-5">Careers</h5>
            <p>Join Our Team and Shape the Future of Technology</p>
            <img src={img1} className="w-100 h-50 rounded" />
          </div>

          <div className="col-md-8">
            <div className="apply-form-card mt-5 mb-4">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  {/* Name */}
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control custom-input"
                      placeholder="Enter Your Name"
                      onChange={handleChange}
                    />
                    <small className="text-danger">{errors.name}</small>
                  </div>

                  {/* Email */}
                  <div className="col-md-6 mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control custom-input"
                      placeholder="Email Address"
                      onChange={handleChange}
                    />
                    <small className="text-danger">{errors.email}</small>
                  </div>

                  {/* Phone */}
                  <div className="col-md-6 mb-3">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control custom-input"
                      placeholder="Phone Number"
                      onChange={handleChange}
                    />
                    <small className="text-danger">{errors.phone}</small>
                  </div>

                  {/* Domain */}
                  <div className="col-md-6 mb-3">
                    <select
                      name="domain"
                      className="form-control custom-input"
                      onChange={handleChange}
                    >
                      <option value="">Select Domain</option>
                      {domains.map((domain, index) => (
                        <option key={index} value={domain}>
                          {domain}
                        </option>
                      ))}
                    </select>
                    <small className="text-danger">{errors.domain}</small>
                  </div>

                  {/* Experience */}
                  <div className="col-md-6 mb-3">
                    <select
                      name="experience"
                      className="form-control custom-input"
                      onChange={handleChange}
                    >
                      <option value="">Total Years of Experience</option>
                      <option>0–1</option>
                      <option>1–3</option>
                      <option>3–5</option>
                      <option>5+</option>
                    </select>
                    <small className="text-danger">{errors.experience}</small>
                  </div>

                  {/* Relevant */}
                  <div className="col-md-6 mb-3">
                    <select
                      name="relevant"
                      className="form-control custom-input"
                      onChange={handleChange}
                    >
                      <option value="">Relevant Experience</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                    <small className="text-danger">{errors.relevant}</small>
                  </div>

                  {/* Date */}
                  <div className="col-md-6 mb-3">
                    <input
                      type="date"
                      name="lastDate"
                      className="form-control custom-input"
                      onChange={handleChange}
                    />
                    <small className="text-danger">{errors.lastDate}</small>
                  </div>

                  {/* File */}
                  <div className="col-md-6 mb-3">
                    <input
                      type="file"
                      name="file"
                      className="form-control custom-input"
                      onChange={handleChange}
                    />
                    <small className="text-danger">{errors.file}</small>
                  </div>

                  {/* Message */}
                  <div className="col-md-12 mb-3">
                    <textarea
                      name="message"
                      className="form-control custom-input"
                      placeholder="Your Message"
                      onChange={handleChange}
                    ></textarea>
                    <small className="text-danger">{errors.message}</small>
                  </div>

                  <div className="col-md-12 text-end">
                    <button type="submit" className="btn apply-btn">
                      SEND MESSAGE →
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Apply;